import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

interface Props {
  userEmail: string;
  displayName?: string;
  onLogout?: () => void;
}

const navigationItems = [
  { path: "/", icon: "🏠", label: "Trang chủ" },
  { path: "/orders", icon: "📦", label: "Orders" },
  { path: "/profile", icon: "👤", label: "Hồ sơ" },
  // { path: "/about", icon: "ℹ️", label: "Về chúng tôi" },
];

export default function Navigation({ userEmail, displayName, onLogout }: Props) {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-slate-800/80 backdrop-blur-sm border-b border-slate-700/50   z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 text-white hover:text-emerald-300 transition-colors">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500/20 to-blue-500/20 border border-emerald-500/30 flex items-center justify-center">
              <span className="text-xl">🍽️</span>
            </div>
            <span className="font-bold text-xl hidden md:block">Lunch Buddy</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all ${
                  isActive(item.path) ? "bg-gradient-to-r from-emerald-500/20 to-blue-500/20 border border-emerald-500/30 text-emerald-300" : "text-slate-300 hover:text-white hover:bg-slate-700/50"
                }`}
              >
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>

          {/* User Menu & Mobile Toggle */}
          <div className="flex items-center gap-3">
            {/* User Info */}
            {/* <div className="hidden sm:flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500/30 to-purple-500/30 border border-blue-500/50 flex items-center justify-center">
                <span className="text-sm">👤</span>
              </div>
              <div className="hidden lg:block">
                <div className="text-white text-sm font-medium">{displayName || "User"}</div>
                <div className="text-slate-400 text-xs">{userEmail}</div>
              </div>
            </div> */}

            {/* Logout Button */}
            {onLogout && (
              <button
                onClick={onLogout}
                className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-xl border border-slate-600/50 bg-slate-700/50 hover:bg-slate-700 text-slate-300 hover:text-white transition-all text-sm"
              >
                <span>👋</span>
                <span className="hidden lg:block">Đăng xuất</span>
              </button>
            )}

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-xl border border-slate-600/50 bg-slate-700/50 hover:bg-slate-700 text-slate-300 hover:text-white transition-all"
            >
              <span className="text-lg">{isMobileMenuOpen ? "✕" : "☰"}</span>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-slate-700/50 py-4 space-y-2">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-all ${
                  isActive(item.path) ? "bg-gradient-to-r from-emerald-500/20 to-blue-500/20 border border-emerald-500/30 text-emerald-300" : "text-slate-300 hover:text-white hover:bg-slate-700/50"
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            ))}

            {/* Mobile User Info */}
            <div className="border-t border-slate-700/50 pt-4 mt-4">
              {/* <div className="flex items-center gap-3 px-4 py-2">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500/30 to-purple-500/30 border border-blue-500/50 flex items-center justify-center">
                  <span className="text-sm">👤</span>
                </div>
                <div>
                  <div className="text-white text-sm font-medium">{displayName || "User"}</div>
                  <div className="text-slate-400 text-xs">{userEmail}</div>
                </div>
              </div> */}

              {onLogout && (
                <button
                  onClick={() => {
                    onLogout();
                    setIsMobileMenuOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                >
                  <span className="text-xl">👋</span>
                  <span>Đăng xuất</span>
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
